import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../store';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton, InputLabel, MenuItem, Select,
  TextField
} from '@mui/material';
import {useForm} from 'react-hook-form';
import {ICreateLeadReference, ILeadConnection} from '../reducers';
import {yupResolver} from '@hookform/resolvers/yup';
import {leadReferenceSchema} from '../../../schemas';
import React, {useEffect} from 'react';
import {getCompany} from '../../center/actions';
import {createLeadReference} from '../actions';
import {Close as CloseIcon, Save as SaveIcon} from '@mui/icons-material';

interface IProps {
  isOpen: boolean
  handleClose: () => void
  leadReferenceConnexions: ILeadConnection[]
}
const AddLeadModal = ({ isOpen, handleClose, leadReferenceConnexions }: IProps) => {
  
  const makers = useSelector((state: RootState) => state.centersReducer.makers)
  const dispatch = useDispatch()
  
  const {
    handleSubmit,
  watch,
  register,
  formState: { errors, isValid },} = useForm<ICreateLeadReference>({
    resolver: yupResolver(leadReferenceSchema)
  })
  
  useEffect(() => {
    new Promise((resolve, reject) => {
      dispatch(getCompany(1000, 0, '', false, 'MAKER', resolve, reject))
    })
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  const handleSave = async (values: ICreateLeadReference) => {
    console.log(`handleSave ${JSON.stringify(values)}`)
    new Promise((resolve, reject) => {
      dispatch(
        createLeadReference(
          {
            ...values,
          },
          resolve,
          reject,
        ),
      )
    })
      .then(() => {
        console.log('handleSave succeed')
        handleClose()
      })
      .catch((err) => {
        console.error(`handleSave failed ${JSON.stringify(err)}`)
      })
  }
  
  const { connection_id} = watch()
  
  return (
      <Dialog
          fullWidth={true}
          maxWidth={'md'}
          open={isOpen}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
          sx={{ padding: '30px auto' }}
          PaperProps={{
            style: { borderRadius: 20 },
          }}
      >
        <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
        >
          <DialogTitle
              id="responsive-dialog-title"
              sx={{
                display: 'flex',
                position: 'relative',
                justifyContent: 'center',
                background: 'linear-gradient(60deg, #84c2ce, #96dcea)',
                color: 'white',
                fontWeight: '700',
                fontSize: '18px',
              }}
          >
            {"Ajout d'une référence de sonde"}
            <IconButton
                sx={{ position: 'absolute', right: '20px' }}
                onClick={handleClose}
            >
              <CloseIcon sx={{ color: 'white' }} />
            </IconButton>
          </DialogTitle>
          <DialogContent
              sx={{
                alignItems: 'center',
                flexDirection: 'column',
              }}
          >
            <form onSubmit={handleSubmit(handleSave)}>
              <Grid container spacing={3} padding={10}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <TextField {...register('reference')}
                        fullWidth
                        name="reference"
                        label="Référence"
                        helperText={errors.reference?.message} />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <TextField {...register('description')}
                               fullWidth
                               name="description"
                               label="Description"
                               helperText={errors.description?.message} />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <TextField {...register('length')}
                        type={'number'}
                               fullWidth
                               name="length"
                               label="Longueur (mm)"
                               helperText={errors.length?.message} />
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth error={!!errors.maker_id}>
                    <InputLabel
                        id="maker_select_label"
                    >
                      Fabricant
                    </InputLabel>
                    <Select
                        {...register('maker_id')}
                        name="maker_id"
                        labelId="maker_select_label"
                        label="Fabricant"
                    >
                      {makers.data.map((maker: any) => (
                          <MenuItem key={maker.id} value={maker.id}>
                            {maker.companyName}
                          </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth error={!!errors.connection_id}>
                    {!connection_id && (
                        <InputLabel
                            id="connexion_select_label"
                            
                        >
                          Connexion
                        </InputLabel>
                    )}
                    <Select
                        {...register('connection_id')}
                        fullWidth
                        name="connection_id"
                        labelId="connexion_select_label"
                        label="Connexion"
                        error={!!errors.connection_id}
                    >
                      {leadReferenceConnexions.map((connection: any) => (
                          <MenuItem key={connection.id} value={connection.id}>
                            {connection.lead_type} - {connection.lead_connection}
                          </MenuItem>
                      ))}
                    </Select>
                    
                  </FormControl>
                </Grid>
              </Grid>
            </form>
          </DialogContent>
          <DialogActions>
            <IconButton
                onClick={handleSubmit(handleSave)}
                sx={{
                  alignSelf: 'right',
                  color: isValid ? '#40D172' : 'default',
                }} // Conditional styling
            >
              <SaveIcon
                  sx={{
                    fontSize: '36px',
                  }}
              />
            </IconButton>
          </DialogActions>
        </div>
      </Dialog>
  )
}

export default AddLeadModal
